import { Route } from '@angular/router';
import { crmLandingRoute } from './crm-route.helpers';

const SALES_CRUMB = { id: 'sales', label: 'Ventas y cobranza' };

export const CRM_SALES_ROUTES: Route[] = [
  crmLandingRoute({
    path: 'sales/clients/clients',
    moduleId: 'sales',
    activeMenubarId: 'sales-clients',
    title: 'Clientes',
    breadcrumbs: [SALES_CRUMB, { id: 'clients', label: 'Clientes' }],
    loadComponent: () =>
      import('../pages/sales/clients/clients/clients.component').then(
        (m) => m.SalesClientsComponent,
      ),
  }),
  crmLandingRoute({
    path: 'sales/quotes/quotes',
    moduleId: 'sales',
    activeMenubarId: 'sales-quotes',
    title: 'Cotizaciones',
    breadcrumbs: [SALES_CRUMB, { id: 'quotes', label: 'Cotizaciones' }],
    loadComponent: () =>
      import('../pages/sales/quotes/quotes/quotes.component').then(
        (m) => m.SalesQuotesComponent,
      ),
  }),
  crmLandingRoute({
    path: 'sales/blocks/blocks',
    moduleId: 'sales',
    activeMenubarId: 'sales-blocks',
    title: 'Bloqueos',
    breadcrumbs: [SALES_CRUMB, { id: 'blocks', label: 'Bloqueos' }],
    loadComponent: () =>
      import('../pages/sales/blocks/blocks/blocks.component').then(
        (m) => m.SalesBlocksComponent,
      ),
  }),
  crmLandingRoute({
    path: 'sales/sales/sales',
    moduleId: 'sales',
    activeMenubarId: 'sales-list',
    title: 'Ventas',
    breadcrumbs: [SALES_CRUMB, { id: 'sales-list', label: 'Ventas' }],
    loadComponent: () =>
      import('../pages/sales/sales/sales/sales.component').then(
        (m) => m.SalesListComponent,
      ),
  }),
  crmLandingRoute({
    path: 'sales/reports/quotes',
    moduleId: 'sales',
    activeMenubarId: 'sales-rep-quotes',
    title: 'Cotizaciones',
    breadcrumbs: [
      SALES_CRUMB,
      { id: 'reports', label: 'Reportes' },
      { id: 'quotes-report', label: 'Cotizaciones' },
    ],
    loadComponent: () =>
      import('../pages/sales/reports/quotes/quotes-report.component').then(
        (m) => m.QuotesReportComponent,
      ),
  }),
  crmLandingRoute({
    path: 'sales/reports/transitory',
    moduleId: 'sales',
    activeMenubarId: 'sales-rep-transitory',
    title: 'Transitorias',
    breadcrumbs: [
      SALES_CRUMB,
      { id: 'reports', label: 'Reportes' },
      { id: 'transitory-report', label: 'Transitorias' },
    ],
    loadComponent: () =>
      import(
        '../pages/sales/reports/transitory/transitory-report.component'
      ).then((m) => m.TransitoryReportComponent),
  }),
  crmLandingRoute({
    path: 'sales/reports/sales',
    moduleId: 'sales',
    activeMenubarId: 'sales-rep-sales',
    title: 'Ventas',
    breadcrumbs: [
      SALES_CRUMB,
      { id: 'reports', label: 'Reportes' },
      { id: 'sales-report', label: 'Ventas' },
    ],
    loadComponent: () =>
      import('../pages/sales/reports/sales/sales-report.component').then(
        (m) => m.SalesReportComponent,
      ),
  }),
];
